import { render, staticRenderFns } from "./GetInvoiceLegalOrder.vue?vue&type=template&id=8ba6b33c&scoped=true&"
import script from "./GetInvoiceLegalOrder.vue?vue&type=script&lang=js&"
export * from "./GetInvoiceLegalOrder.vue?vue&type=script&lang=js&"
import style0 from "./GetInvoiceLegalOrder.vue?vue&type=style&index=0&id=8ba6b33c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba6b33c",
  null
  
)

export default component.exports